import { aboutFaqs, testimonials, siteInfo } from '@/mocks/feed';
import { useSeo } from '@/hooks/useSeo';
import Breadcrumb from '@/components/feature/Breadcrumb';
import FaqAccordion from '@/components/feature/FaqAccordion';
import SectionHeading from '@/components/base/SectionHeading';
import AboutIntro from './components/AboutIntro';
import AboutValues from './components/AboutValues';
import AboutContact from './components/AboutContact';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于夜半瓜社',
    url: `${siteInfo.domain}/about`,
    inLanguage: 'zh-CN',
    description: '了解夜半瓜社的网站定位、内容原则与联系方式。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: `${siteInfo.domain}/`,
    email: siteInfo.email,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: aboutFaqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: `${siteInfo.domain}/` },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: `${siteInfo.domain}/about` },
    ],
  },
];

export default function About() {
  useSeo({
    title: '关于我们｜夜半瓜社的值夜方式与内容原则',
    description:
      '了解夜半瓜社的网站定位、内容原则、发展理念与联系方式：我们如何整理深夜黑料与午夜话题，如何处理待核信息，以及为什么建议天亮再判断。',
    keywords: '关于夜半瓜社,内容原则,深夜黑料整理,午夜话题核实,联系方式',
    path: '/about',
    ogType: 'website',
    jsonLd,
  });

  return (
    <main className="mx-auto w-full max-w-[1440px] px-4 pt-24 pb-16 md:px-8 md:pt-28 md:pb-20">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

      <div className="mt-8">
        <AboutIntro />
        <AboutValues />
      </div>

      <section className="mt-16 border-t border-background-200/70 pt-14">
        <SectionHeading
          eyebrow="Night Owls Say"
          title="用户口碑：来自长期熬夜的读者"
          desc="他们大多数不是来看结论的，只是想弄清楚事情走到哪一步了。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100/50 p-5">
              <i className="ri-double-quotes-l text-2xl text-accent-500/50" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500/20 font-label text-sm text-secondary-200">
                  {t.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm text-foreground-900">{t.name}</span>
                  <span className="block text-xs text-foreground-500">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section id="faq" className="mt-16 border-t border-background-200/70 pt-14">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于深夜黑料整理，你可能会关心的几个问题都在这里。"
        />
        <FaqAccordion items={aboutFaqs} />
      </section>

      <AboutContact />
    </main>
  );
}